// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__25B9O","title":"InfoRow_title__1pCXC"};